import { Tooltip as ReactTooltip, ITooltip as IReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import styles from "./Tooltip.module.scss";

const Tooltip = ({ ...props }: IReactTooltip): JSX.Element => (
    <ReactTooltip {...props} place="top" variant="light" className={styles.tooltip} />
);

export default Tooltip;
